import axios from 'axios'
import qs from 'qs'
import {
  saveState,
  getSavedState
} from '@state/helpers'
import mapApiUrl from '@/src/utils/api-mapper'

export const state = {
  wellList: [],
  fieldList: getSavedState('field.fieldList'),
  padList: getSavedState('field.padList'),
}

export const mutations = {
  SET_WELL_LIST(state, newValue) {
    state.wellList = newValue
  },
  SET_FIELD_LIST(state, newValue) {
    state.fieldList = newValue
    saveState('field.fieldList', newValue)
  },
  SET_PAD_LIST(state, newValue) {
    state.padList = newValue
    saveState('field.padList', newValue)
  },
}

export const getters = {
  fieldData(state) {
    return state.fieldList || []
  },
  padData(state) {
    return state.padList || []
  },
  wellData(state) {
    return state.wellList || []
  },
}

export const actions = {

  setWellList({
    commit
  }, wellList) {
    commit('SET_WELL_LIST', wellList)
  },

  setFieldList({
    commit
  }, fieldList) {
    commit('SET_FIELD_LIST', fieldList)
  },

  setPadList({
    commit
  }, padList) {
    commit('SET_PAD_LIST', padList)
  },

  getWellList({
    commit,
    dispatch,
    getters
  }, {
    params
  } = {}) {
    const url = mapApiUrl('/api/well/assets/wells/list')
    return axios
      .get(url, {
        params: params
      })
      .then((response) => {
        let list = response ? response.data.data : null
        list.content.forEach(member => {
          member.totalDays = member.totalDays ? member.totalDays.toFixed(2) : 'N/A'
        })
        dispatch('setWellList', list ? list.content : [])
        return response
      })
  },

  getFieldList({
    commit,
    dispatch,
    getters
  }, {
    params
  } = {}) {
    const url = mapApiUrl('/api/well/assets/fields/list')
    return axios
      .get(url, {
        params: params
      })
      .then((response) => {
        const list = response ? response.data.data : null
        dispatch('setFieldList', list ? list.content : [])
        return response
      })
  },

  getFields({
    commit,
    dispatch,
    getters
  }, {
    params
  } = {}) {
    const url = mapApiUrl('/api/well/assets/fields/list/option')
    return axios
      .get(url, {
        params: params
      })
      .then((response) => {
        return response
      })
  },

  getPads({
    commit,
    dispatch,
    getters
  }, {
    params
  } = {}) {
    const url = mapApiUrl('/api/well/assets/pads/list/option')
    return axios
      .get(url, {
        params: params
      })
      .then((response) => {
        return response
      })
  },

  getWells({
    commit,
    dispatch,
    getters
  }, {
    params
  } = {}) {
    const url = mapApiUrl('/api/well/assets/wells/list/option')
    return axios
      .get(url, {
        params: params
      })
      .then((response) => {
        return response
      })
  },

  getWellInfo({
    commit,
    dispatch,
    getters
  }, {
    params
  } = {}) {
    const url = mapApiUrl('/api/well/assets/wells/info')
    return axios
      .get(url, {
        params: params
      })
      .then((response) => {
        return response
      })
  },

  getWellStatus({
    commit,
    dispatch,
    getters
  }, {
    params
  } = {}) {
    const url = mapApiUrl('/api/well/assets/wells/status')
    return axios
      .get(url, {
        params: params
      })
      .then((response) => {
        return response
      })
  },

  getPadList({
    commit,
    dispatch,
    getters
  }, {
    params
  } = {}) {
    const url = mapApiUrl('/api/well/assets/pads/list')
    return axios
      .get(url, {
        params: params
      })
      .then((response) => {
        const list = response ? response.data.data : null
        dispatch('setPadList', list ? list.content : [])
        return response
      })
  },

  addField({
    commit,
    dispatch,
    getters
  }, {
    params
  } = {}) {
    const url = mapApiUrl('/api/well/assets/fields/add')
    return axios
      .post(url, qs.stringify(params))
      .then((response) => {
        return response
      })
  },

  addPad({
    commit,
    dispatch,
    getters
  }, {
    params
  } = {}) {
    const url = mapApiUrl('/api/well/assets/pads/add')
    return axios
      .post(url, qs.stringify(params))
      .then((response) => {
        return response
      })
  },

  addWell({
    commit,
    dispatch,
    getters
  }, {
    params
  } = {}) {
    const url = mapApiUrl('/api/well/assets/wells/add')
    return axios
      .post(url, qs.stringify(params))
      .then((response) => {
        return response
      })
  },

  updateField({
    commit,
    dispatch,
    getters
  }, {
    params
  } = {}) {
    const url = mapApiUrl('/api/well/assets/fields/update')
    return axios
      .post(url, qs.stringify(params))
      .then((response) => {
        return response
      })
  },

  updatePad({
    commit,
    dispatch,
    getters
  }, {
    params
  } = {}) {
    const url = mapApiUrl('/api/well/assets/pads/update')
    return axios
      .post(url, qs.stringify(params))
      .then((response) => {
        return response
      })
  },

  updateWell({
    commit,
    dispatch,
    getters
  }, {
    params
  } = {}) {
    const url = mapApiUrl('/api/well/assets/wells/update')
    return axios
      .post(url, qs.stringify(params))
      .then((response) => {
        return response
      })
  },

  deleteField({
    commit,
    dispatch,
    getters
  }, {
    params
  } = {}) {
    const url = mapApiUrl('/api/well/assets/fields/remove')
    return axios
      .delete(url, {
        params: params
      })
      .then((response) => {
        return response
      })
  },

  deletePad({
    commit,
    dispatch,
    getters
  }, {
    params
  } = {}) {
    const url = mapApiUrl('/api/well/assets/pads/remove')
    return axios
      .delete(url, {
        params: params
      })
      .then((response) => {
        return response
      })
  },

  deleteWell({
    commit,
    dispatch,
    getters
  }, {
    params
  } = {}) {
    const url = mapApiUrl('/api/well/assets/wells/remove');
    // let validateStatus = function(status) {
    //   return status < 205; // Reject only if the status code is greater than or equal to 500
    // }
    return axios
      .delete(url, {
        params: params
      })
      .then((response) => {
        return response
      })
  },

}
